import { Target, Smartphone, Cloud, TrendingUp } from 'lucide-react';
import ServiceCard from "@/components/common/ui/Card";

export default function ServicesSection() {
	const services = [
		{
			icon: Target,
			title: "IT Strategy Consulting",
			description: "We provide strategic guidance to help you navigate the complexities of IT, aligning technology with your business objectives for maximum impact.",
			gradient: "from-blue-500 to-cyan-500"
		},
		{
			icon: Smartphone,
			title: "Web & Mobile Apps",
			description: "We create Web and Mobile app solutions tailored to meet the unique needs of your business, ensuring seamless integration and optimal performance",
			gradient: "from-purple-500 to-pink-500"
		},
		{
			icon: Cloud,
			title: "Cloud Solutions",
			description: "Leverage the power of cloud computing with our comprehensive services, designed to enhance scalability, flexibility, and security.",
			gradient: "from-blue-500 to-purple-500"
		},
		{
			icon: TrendingUp,
			title: "Data Analytics & Insights",
			description: "Unlock the potential of your data with our analytics services, providing actionable insights to drive informed decision-making and business growth.",
			gradient: "from-cyan-500 to-blue-500"
		}
	];

	return (
		<section className="relative py-16 md:py-24 overflow-hidden">
			{/* Animated background elements */}
			<div className="absolute inset-0 opacity-20">
				<div className="absolute top-20 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
				<div className="absolute bottom-20 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
			</div>

			<div className="container relative z-10">
				{/* Section Header */}
				<div className="text-center mb-16">
					{/* <div className="inline-block mb-4">
						<span className="text-blue-400 text-sm font-semibold tracking-wider uppercase px-4 py-2 bg-blue-500/10 rounded-full border border-blue-500/20">
							Our Services
						</span>
					</div> */}
					<h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
						What We{" "}
						{/* <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent"> */}
							Offer
						{/* </span> */}
					</h2>
					{/* <p className="text-gray-300 md:text-lg max-w-2xl mx-auto">
						Comprehensive IT solutions designed to transform your business
					</p> */}
				</div>

				{/* Services Grid */}
				<div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
					{services.map((service, index) => (
						<ServiceCard
							key={index}
							icon={service.icon}
							title={service.title}
							description={service.description}
						/>
					))}
				</div>
			</div>
		</section>
	);
}